//Librerias
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import { useEffect } from 'react'
//Componentes
import Benefits from '../components/LandingComponents/Benefits'
import Copyright from '../components/home/Copyright'
import Whatsapp from '../components/LandingComponents/Whatsapp'
import { login } from '../api/login';
import { contactEmail } from '../api/sendEmail';
import { showConfirmToast } from '../components/home/DeviceComponents/ConfirmToast';
//Res
import logo from '../res/landing/logo_colton_1.svg'
import map from '../res/landing/map.png'
import dashboard from '../res/landing/dashboard.png'
import white_logo from '../res/landing/footer/white_logo.png'
import mail from '../res/landing/footer/mail.svg'
import location from '../res/landing/footer/location.svg'
import whatsapp_ico from '../res/landing/footer/whatsapp_icon.svg'



function Landing() {
  const navigate = useNavigate();

	useEffect(()=>{
		const user = JSON.parse(localStorage.getItem("user"));
		if(user?.token && user?.id){
			navigate("/home");
		}
	}, [navigate]);


  return (
    <Container>
      <ToastContainer
        position="top-center"
        hideProgressBar={false}
        newestOnTop={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        closeOnClick={false}
        rtl={false}
        theme="light"
      />
      <Intro>
        <img className='logo' src={logo} alt="Logo" />
        <button className="more-info" onClick={scrollToBottom}>Solicitar información</button>
        <p className="title">Monitoreo energético inteligente con tecnologías de IoT</p>
        <p className="sub-title">Somos una empresa especializada en soluciones IoT, actualmente enfocada en la medición remota e inteligente del consumo eléctrico. <br/><br/>
          Nuestra tecnología es escalable a sectores como agua, gas, agro y petróleo, y permite operar incluso en entornos sin acceso a internet, red celular o energía eléctrica.
        </p>
        
      </Intro>
      <Benefits/>
      <div className="demo-login">
            <img className='dashboard' src={dashboard} alt="Dashboard" />
            <img className='map' src={map} alt="Mapa" />
            <form id="log_in" className="log-in" onSubmit={sendLogin}>
              <p>Iniciar Sesión</p>
              <input type="text" placeholder="Correo electrónico" name="email" required/>
              <input type="password" placeholder="Contraseña" name="password" required/>
              <button type="submit">Iniciar sesión</button>
            </form>
      </div>
      <End>
        <div className='footer-grid'>
          <div className='logo'>
            <img src={white_logo} alt="Logo" />
          </div>
          <div className='info'>
            <div className='row'>
              <img src={mail} alt="Mail ico" />
              <p>info@coltoncobi.com</p>
            </div>
            <div className='row'>
              <img src={location} alt="Location ico" />
              <p>Juan José Paso 60, Firmat, Santa Fé</p>
            </div>
            <div className='row'>
              <img src={whatsapp_ico} alt="Whatsapp ico" />
              <p>+543465666782</p>
            </div>
          </div>
          <div className="contact_us">
            <form action="" onSubmit={sendContactRequest}>
              <p>SOLICITAR INFORMACIÓN</p>
              <input type="text" placeholder='Dirección de Email'/>
              <button type="submit">Enviar</button>
            </form>
          </div>
        </div>
        <Copyright/>
      </End>
      <Whatsapp/>
    </Container>
  )
}

function scrollToBottom() {
  
  //const scrollHeight = document.body.scrollHeight;

  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: 'smooth'
  });
}

async function sendLogin(e) {
  e.preventDefault();

  const form = e.target;
  const button = form.querySelector("button");
  button.disabled = true;
  button.classList.add("loading");
  const email = form.email.value;
  const password = form.password.value;

  const loginPromise = login(email, password);

  try {
    const response = await toast.promise(loginPromise, {
      pending: "Iniciando sesión...",
      success: {
        render: "Inicio exitoso",
        autoClose: 2000
      },
      error: {
        render: ({ data }) => data.message || "Error",
        autoClose: 5000
      }
    });

    if(response.error !== false){
      throw new Error(response.message || "Error al iniciar sesión");
    }
    const userData = {
      token : response.body.token,
      id : response.body.id
    }
    localStorage.setItem("user", JSON.stringify(userData));
    window.location.href = "./home";
    

  } catch (err) {
    console.error(err);
    button.disabled = false;
    button.classList.remove("loading");
  }
}

async function sendContactRequest(e) {
  e.preventDefault();
  console.log("Enviando solicitud de contacto...");
  const form = e.target;
  const formbutton = form.querySelector("button");
  formbutton.disabled = true;
  formbutton.classList.add("loading");
  const email = form[0].value;
  if(!email){
    toast.error("Por favor ingresa un email válido", {
      position: "top-center",
      autoClose: 1000,
      className: "!rounded-xl",
    })
    formbutton.disabled = false;
    formbutton.classList.remove("loading");
    return;
  }

  const confirmed = await showConfirmToast(
    `¿El email ingresado es correcto? ${email}`
  );

  if (!confirmed) {
    toast.warning("Acción cancelada", {
      position: "top-center",
      autoClose: 1000,
      className: "!rounded-xl",
    })
    formbutton.disabled = false;
    formbutton.classList.remove("loading");
    return;
  }

  const contactEmailPromise = contactEmail(email);

  try {
    const response = await toast.promise(contactEmailPromise, {
      pending: "Enviando email...",
      success: {
        render: "Email enviado exitosamente",
        autoClose: 2000
      },
      error: {
        render: ({ data }) => data.message || "Error",
        autoClose: 5000
      }
    });
    formbutton.disabled = false;
    formbutton.classList.remove("loading");

  } catch (err) {
    console.error(err);
  }
}


const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 40px;

  .demo-login{
    display: grid;
    width: 60vw;
    height: auto;
    margin: 10vh auto 0 auto;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 15px;
    grid-row-gap: 15px;
    
    img{
      border-radius: 15px;
      box-shadow: 2px 2px 5px rgba(0, 0, 0, .3);
      height: auto;
      width: 25vw;
    }

    .dashboard{
      grid-area: 1 / 1 / 2 / 2;
    }
    
    .map{
      grid-area: 2 / 1 / 3 / 2;
    }

    .log-in{
      margin: auto;
      grid-area: 1 / 2 / 3 / 3;
      width: 30vw;
      height: 55vh;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 2px 2px 5px rgba(0, 0, 0, .3);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .log-in p{
      font-family: 'montserrat', sans-serif;
      font-size: 24px;
      font-weight: 700;
      line-height: 100%;
      text-align: center;
      color: #2858A2;
      margin-top: 20px;
    }

    .log-in input{
      width: 80%;
      height: 40px;
      margin: 20px auto 0 auto;
      border-radius: 8px;
      border: 1px solid #ccc;
      padding-left: 10px;
      font-family: 'montserrat', sans-serif;
    }

    .log-in button{
      width: 50%;
      height: 40px;
      margin-top: 30px;
      border-radius: 8px;
      border: none;
      background-color: #2858A2;
      color: #fff;
      font-size: 1.1rem;
      font-family: 'montserrat', sans-serif;
      cursor: pointer;
      transition: background-color 0.3s ease;
    }

    .log-in button:hover{
      background-color: #1f3d6b;
    }

    .log-in .loading{
      background-color: #1f3d6b;
      cursor: default;
    }

  }
`

const Intro = styled.div`
  height: auto;
  width: 80%;
  margin: 4% auto 0 auto;
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-template-rows: repeat(4, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 0px;

  .logo{
    grid-area: 1 / 1 / 4 / 2;
    display: flex;
    height: 20vh;
    width: auto;
    justify-content: center;
    align-items: center;
    margin: auto;
  }

  .title{
    grid-area: 1 / 2 / 3 / 3;
    font-family: 'montserrat', sans-serif;
    font-size: 2.2rem/*clamp(1rem, calc(7vw + 1rem), 3rem)*/;
    font-weight: 400;
    line-height: 100%;
    text-align: left;
    color: #2858A2;
    font-style: bold;
    letter-spacing: 0%;
    margin: auto auto auto 0;
  }

  .sub-title{
    grid-area: 3 / 2 / 5 / 3;
    font-family: 'montserrat', sans-serif;
    font-size: 18px/*clamp(0.5rem, calc(7vw + 1rem), 1.25rem)*/;
    font-weight: 400;
    line-height: 2rem;
    text-align: left;
    color: #2858A2;
    font-style: semi-bold;
    letter-spacing: 0%;
    margin: -1.5rem auto;
  }

  .more-info{
    margin: auto;
    grid-area: 4 / 1 / 5 / 2;
    min-width: 178px;
    background-color: #2858A2;
    color: #fff;
    font-family: 'montserrat', sans-serif;
    border: none;
    border-radius: 8px;
    transition: background-color 0.3s ease;

    display: flex;
    width: 9.625rem;
    height: 2.875rem;
    padding: 0.625rem 0.125rem;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    margin-top: 6%;
  }

  .more-info:hover{
    cursor: pointer;
    background-color: #1f3d6b;
  }

`

const End = styled.footer`
  background: #2858A2;
  color: white;
  height: 22vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 0 10px 0;
  align-items: center;
  gap: 10px;

  .footer-grid{
    display: grid;
    grid-template-columns: 1fr repeat(2, 2fr);
    grid-template-rows: 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 0px;

    .logo{
      grid-area: 1 / 1 / 2 / 2;
      margin: auto;
      height: auto;
      width: 8vw;
      margin-top: 20px;
    }

    .info{
      grid-area: 1 / 2 / 2 / 3;
      padding-top: 10px;

      p{
        margin: 10px;
        padding: 0;
      }

      >*{
        display: flex;
        flex-direction: row;
      }
    }

    .contact_us{
      grid-area: 1 / 3 / 2 / 4;

      form{
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;

        input{
          border: none;
          border-radius: 8px;
          text-align: center;
          width: 100%;
          height: 40px;
        }

        button{
          border: none;
          border-radius: 8px;
          text-align: center;
          height: 40px;
          width: 30%;
          color: #000;
          background-color: #34C759;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        button:hover{
          background-color: #28A745;
        }

        .loading {
          background-color: #28A745;
          cursor: default;
        }
      }

      p{
        margin: 4% 0 0 0;
        padding: 0;
      }
    }
  }
  
`
export default Landing